import React, { useState, useEffect } from 'react';
import '../../styles/sections/Gallery.css';

function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const galleryItems = [
    {
      image: "/gallery/wedding.png",
      title: "Wedding Day Memories",
      description: "Capture your special day in a unique way"
    },
    {
      image: '/gallery/pet.png',
      title: 'Pet Portraits',
      description: 'Celebrate your furry friends'
    },
    {
      image: '/gallery/family.png',
      title: 'Family Photos',
      description: 'Keep loved ones close'
    },
    {
      image: '/gallery/travel.png',
      title: 'Travel Moments',
      description: 'Remember your adventures'
    },
    {
      image: '/gallery/baby.png',
      title: 'Baby Milestones',
      description: 'Capture growing moments'
    },
    {
      image: '/gallery/memorial.png',
      title: 'Memorial Tiles',
      description: 'Honor special memories'
    }
  ];

  // Create a looped array for smooth infinite scrolling
  const loopedItems = [...galleryItems, ...galleryItems.slice(0, 3)];

  // Add resize listener
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    
    setCurrentIndex((prevIndex) => {
      const nextIndex = prevIndex + 1;
      // If we're at the end, quickly reset to start after animation
      if (nextIndex >= galleryItems.length) {
        setTimeout(() => {
          setIsTransitioning(false);
          setCurrentIndex(0);
        }, 500);
      } else {
        setTimeout(() => {
          setIsTransitioning(false);
        }, 500);
      }
      return nextIndex;
    });
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);

    setCurrentIndex((prevIndex) => {
      if (prevIndex === 0) {
        // Jump to end instantly, then animate backwards
        setCurrentIndex(galleryItems.length);
        setTimeout(() => {
          setIsTransitioning(true);
          setCurrentIndex(galleryItems.length - 1);
        }, 0);
      } else {
        return prevIndex - 1;
      }
      setTimeout(() => {
        setIsTransitioning(false);
      }, 500);
      return prevIndex;
    });
  };

  return (
    <section id="gallery" className="gallery">
      <div className="gallery-content">
        <h2>Gallery</h2>
        <p className="gallery-subtitle">
          See how others have transformed their photos into beautiful ceramic tiles
        </p>
        <div className="gallery-carousel-container">
          <button 
            className="gallery-nav-button prev" 
            onClick={prevSlide}
            disabled={isTransitioning}
            aria-label="Previous slide"
          >
            ‹
          </button>
          <div className="gallery-grid-wrapper">
            <div 
              className="gallery-grid"
              style={{
                transform: `translateX(-${currentIndex * (isMobile ? 100 : 100/3)}%)`,
                transition: isTransitioning ? 'transform 0.5s ease' : 'none'
              }}
            >
              {loopedItems.map((item, index) => (
                <div 
                  key={index} 
                  className="gallery-item"
                >
                  <div className="gallery-image-container">
                    <img 
                      src={item.image} 
                      alt={item.title}
                      className="gallery-image"
                    />
                  </div>
                  <div className="gallery-text">
                    <h3>{item.title}</h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <button 
            className="gallery-nav-button next" 
            onClick={nextSlide}
            disabled={isTransitioning}
            aria-label="Next slide"
          >
            ›
          </button>
        </div>
        <div className="gallery-dots">
          {Array.from({ length: galleryItems.length }).map((_, idx) => (
            <button
              key={idx}
              className={`gallery-dot ${currentIndex === idx ? 'active' : ''}`}
              onClick={() => !isTransitioning && setCurrentIndex(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Gallery; 